import React from 'react'
import { RegularCheckBox } from '../../HouseStyle/Components/Checkboxes';

const CheckboxGrid = ({ exportOptions, selectedTable, selectedGroupTables, handleCheckboxChange }) => {
    let itemList = {};
    let checkboxesAdded = 0;
    
    // Build itemList grouping every 3 elements
    Object.entries(exportOptions.groupOptions[exportOptions.exportTypes[selectedTable].displayName]).forEach(([key, value]) => {
        const groupIndex = Math.floor(checkboxesAdded / 3);
        if (!itemList[groupIndex]) {
            itemList[groupIndex] = [];
        }
        itemList[groupIndex].push({ key, displayName: value.displayName });
        checkboxesAdded++;
    });

    return (
        <div className="checkbox-grid-container d-flex flex-row gap-3">
            {Object.values(itemList).map((group, groupIndex) => (
                <div key={groupIndex} className="d-flex flex-column"> {/* Each group of three in a separate div */}
                    {group.map(({ key, displayName }) => (
                        <div key={key} style={{ flexBasis: '33.33%' }}>
                            <RegularCheckBox
                                label={displayName}
                                value={selectedGroupTables.includes(key)}
                                setValue={() => handleCheckboxChange(key)}
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

export default CheckboxGrid;
